module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-60x60-precomposed-b4798f6e7b31fd3736acc2495a5e0fef.png";